import Vue from 'vue';

export const User = {
  state: {
    user: null
  },
  actions: {
    logoutUser ({ commit }) {
      commit('setUser', null);
    }
  },
  mutations: {
    setUser (state, user) {
      Vue.set(state, 'user', JSON.parse(JSON.stringify(user)));
    }
  },
  getters: {
    getUser (state) {
      return state.user;
    },
    getUserName (state) {
      if (!state.user) {
        return null;
      }

      return state.user.name;
    },
    getUserType (state) {
      if (!state.user) {
        return null;
      }

      return state.user.type;
    },
    get2faStatus (state) {
      if (!state.user) {
        return false;
      }

      return state.user.google2fa_enabled;
    }
  }
};

export default User;
